import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { getCategoryDetails } from "store/actions/categoriesAction"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { useTranslation } from "react-i18next"

const CategoryDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Category Details | Sign Burger")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const { loading, categoryDetails } = useSelector(state => state.Categories)
  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    if (!id || id === "undefined" || !/^[a-f\d]{24}$/i.test(id)) {
      return
    }
    dispatch(getCategoryDetails({ id }))
  }

  return (
    <div className="page-content category_page">
      <div className="container-fluid">
        <Breadcrumbs />
        {loading ? (
          <Card>
            <CardBody>
              <Row>
                <Col lg={8}>
                  <ShimmerThumbnail height={430} rounded />
                </Col>
                <Col lg={4}>
                  <ShimmerThumbnail height={430} rounded />
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 d-flex align-items-center">
                    <BackButton /> {t("Category Details")}
                  </CardTitle>
                  <div className="table-responsive">
                    {Object.values(categoryDetails).length === 0 ? (
                      <p className="text-center">
                        {t("No category details found")}
                      </p>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{categoryDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(English)")}</th>
                            <td>{categoryDetails.name || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(عربي)")}</th>
                            <td>{categoryDetails.nameAr || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {categoryDetails.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Description(English)")}</th>
                            <td>{categoryDetails.description || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Description(عربي)")}</th>
                            <td>{categoryDetails.descriptionAr || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Image Type")}</th>
                            <td>{categoryDetails.imageUrlType || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Display Order")}</th>
                            <td>
                              {categoryDetails.displayOrder !== undefined
                                ? categoryDetails.displayOrder
                                : "-"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="card_100_24">
                <CardBody>
                  <img
                    src={categoryDetails.imageUrl}
                    alt=""
                    className="img-fluid d-block mx-auto"
                    style={{ height: "100%", objectFit: "contain" }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default CategoryDetails
